import { ELikeType } from '../types/likes';
import { ICommentParent } from '../types/commentList';

export const LikeTypeLikedUsers: { [key in ELikeType]: keyof Pick<ICommentParent, 'likedUsers' | 'dislikedUsers'> } = {
  [ELikeType.Like]: 'likedUsers',
  [ELikeType.Dislike]: 'dislikedUsers',
};
